/**
 * Use the standard Select2 control for selects in the reskinned registration flow.
 *
 * @param $elements
 */
const initializeReskinSelects = ($elements) => {
  if (
    !$('body').hasClass('reg-checkout-reskin')
    || typeof $.fn.select2 !== 'function'
  ) {
    return;
  }

  $elements
    .not('.select2-hidden-accessible')
    .not('.d-none')
    .each((index, element) => {
      const $element = $(element);
      const placeholder = $element.find('option[value=""], option[data-placeholder]').first().text();

      $element
        .attr('data-js-select2', 'true')
        .select2({
          minimumResultsForSearch: Infinity,
          width: '100%',
          placeholder: placeholder || '',
        });

      // First pick of the first real option can update Select2's label without
      // writing the native value. Force the native select so serialize() persists it.
      $element.on('select2:select', (event) => {
        const selected = event.params?.data?.id;

        if (selected === undefined || $element.val() === selected) {
          return;
        }

        $element.val(selected).trigger('change');
      });
    });
};

/**
 * Keep a Select2 display in sync after a programmatic .val() without firing native change.
 *
 * @param $el
 */
const syncReskinSelect = ($el) => {
  if (!$el.length || !$el.hasClass('select2-hidden-accessible')) {
    return;
  }

  const value = $el.val();

  // Date-picker / Twig leave selected on the disabled placeholder. Select2 then
  // treats the control as empty when the dropdown opens.
  $el.find('option').each((_, option) => {
    option.selected = value ? option.value === value : option.value === '';
  });

  $el.trigger('change.select2');
};

/**
 * Remove Select2 markup from a select that geography has hidden (text field is showing).
 *
 * @param $el
 */
const destroyReskinSelect = ($el) => {
  if (typeof $.fn.select2 === 'function' && $el.hasClass('select2-hidden-accessible')) {
    $el.select2('destroy');
  }
};

initializeReskinSelects.syncReskinSelect = syncReskinSelect;
initializeReskinSelects.destroyReskinSelect = destroyReskinSelect;

module.exports = initializeReskinSelects;
